import { Typography } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { DateTime, DateTimeService, LocalizedMonthName } from '@mews/framework';

interface ProductOrderLabelProps {
    dateTime: DateTime;
}

export const YearMonthLabel: React.FC<ProductOrderLabelProps> = ({ dateTime }) => {
    const year = DateTimeService.getYear(dateTime);
    return (
        <Typography textStyle="bodyMediumStrong" as="div">
            <LocalizedMonthName dateTime={dateTime} />
            {UnicodeEntity.NoBreakSpace}
            {year}
        </Typography>
    );
};
